// Strong slider pagination implementation: updates only the current index

! function (t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarousel = e()
}(this, (function() {
    "use strict";

    function t(t) {
        return "number" == typeof t
    }

    function e(t) {
        return "string" == typeof t
    }

    function n(t) {
        return "boolean" == typeof t
    }

    function o(t) {
        return "[object Object]" === Object.prototype.toString.call(t)
    }

    function i(t) {
        return Math.abs(t)
    }

    function r(t) {
        return Math.sign(t)
    }

    function s(t, e) {
        return i(t - e)
    }

    function c(t) {
        return f(t).map(Number)
    }

    function a(t) {
        return t[u(t)]
    }

    function u(t) {
        return Math.max(0, t.length - 1)
    }

    function l(t, e) {
        return e === u(t)
    }

    function d(t, e = 0) {
        return Array.from(Array(t), ((t, n) => e + n))
    }

    function f(t) {
        return Object.keys(t)
    }

    function p(t, e) {
        return [t, e].reduce(((t, e) => (f(e).forEach((n => {
            const i = t[n],
                r = e[n],
                s = o(i) && o(r);
            t[n] = s ? p(i, r) : r
        })), t)), {})
    }

    function m(t, e) {
        return void 0 !== e.MouseEvent && t instanceof e.MouseEvent
    }

    function g() {
        let t = [];
        const e = {
            add: function(n, o, i, r = {
                passive: !0
            }) {
                let s;
                if ("addEventListener" in n) n.addEventListener(o, i, r), s = () => n.removeEventListener(o, i, r);
                else {
                    const t = n;
                    t.addListener(i), s = () => t.removeListener(i)
                }
                return t.push(s), e
            },
            clear: function() {
                t = t.filter((t => t()))
            }
        };
        return e
    }

    function h(t = 0, e = 0) {
        const n = i(t - e);

        function o(e) {
            return e < t
        }

        function r(t) {
            return t > e
        }

        function s(t) {
            return o(t) || r(t)
        }
        return {
            length: n,
            max: e,
            min: t,
            constrain: function(n) {
                return s(n) ? o(n) ? t : e : n
            },
            reachedAny: s,
            reachedMax: r,
            reachedMin: o,
            removeOffset: function(t) {
                return n ? t - n * Math.ceil((t - e) / n) : t
            }
        }
    }

    function v(t, e, n) {
        const {
            constrain: o
        } = h(0, t), r = t + 1;
        let s = c(e);

        function c(t) {
            return n ? i((r + t) % r) : o(t)
        }

        function a() {
            return s
        }

        function u() {
            return v(t, a(), n)
        }
        const l = {
            get: a,
            set: function(t) {
                return s = c(t), l
            },
            add: function(t) {
                return u().set(a() + t)
            },
            clone: u
        };
        return l
    }

    function b(t, e, o, c, a, u, l, d, f, p, v, b, y, S, x, E, w, M, L) {
        const {
            cross: T,
            direction: D
        } = t, O = ["INPUT", "SELECT", "TEXTAREA"], A = {
            passive: !1
        }, I = g(), F = g(), P = h(50, 225).constrain(S.measure(20)), N = {
            mouse: 300,
            touch: 400
        }, V = {
            mouse: 500,
            touch: 600
        }, C = x ? 43 : 25;
        let k = !1,
            z = 0,
            H = 0,
            B = !1,
            j = !1,
            q = !1,
            R = !1;

        function W(t) {
            if (!m(t, c) && t.touches.length >= 2) return U(t);
            const e = u.readPoint(t),
                n = u.readPoint(t, T),
                o = s(e, z),
                i = s(n, H);
            if (!j && !R) {
                if (!t.cancelable) return U(t);
                if (j = o > i, !j) return U(t)
            }
            const r = u.pointerMove(t);
            o > E && (q = !0), p.useFriction(.3).useDuration(.75), d.start(), a.add(D(r)), t.preventDefault()
        }

        function U(t) {
            const e = v.byDistance(0, !1).index !== b.get(),
                n = u.pointerUp(t) * (x ? V : N)[R ? "mouse" : "touch"],
                o = function(t, e) {
                    const n = b.add(-1 * r(t)),
                        o = v.byDistance(t, !x).distance;
                    return x || i(t) < P ? o : w && e ? .5 * o : v.byIndex(n.get(), 0).distance
                }(D(n), e),
                c = function(t, e) {
                    if (0 === t || 0 === e) return 0;
                    if (i(t) <= i(e)) return 0;
                    const n = s(i(t), i(e));
                    return i(n / t)
                }(n, o),
                a = C - 10 * c,
                l = M + c / 50;
            j = !1, B = !1, F.clear(), p.useDuration(a).useFriction(l), f.distance(o, !x), R = !1, y.emit("pointerUp")
        }

        function X(t) {
            q && (t.stopPropagation(), t.preventDefault(), q = !1)
        }
        return {
            init: function(t) {
                if (!L) return;

                function i(i) {
                    (n(L) || L(t, i)) && function(t) {
                        const n = m(t, c);
                        R = n, q = x && n && !t.buttons && k, k = s(a.get(), l.get()) >= 2, n && 0 !== t.button || function(t) {
                            const e = t.nodeName || "";
                            return O.includes(e)
                        }(t.target) || (B = !0, u.pointerDown(t), p.useFriction(0).useDuration(0), a.set(l), function() {
                            const t = R ? o : e;
                            F.add(t, "touchmove", W, A).add(t, "touchend", U).add(t, "mousemove", W, A).add(t, "mouseup", U)
                        }(), z = u.readPoint(t), H = u.readPoint(t, T), y.emit("pointerDown"))
                    }(i)
                }
                const r = e;
                I.add(r, "dragstart", (t => t.preventDefault()), A).add(r, "touchmove", (() => {}), A).add(r, "touchend", (() => {})).add(r, "touchstart", i).add(r, "mousedown", i).add(r, "touchcancel", U).add(r, "contextmenu", U).add(r, "click", X, !0)
            },
            destroy: function() {
                I.clear(), F.clear()
            },
            pointerDown: function() {
                return B
            }
        }
    }

    function y(t, e) {
        let n, o;

        function r(t) {
            return t.timeStamp
        }

        function s(n, o) {
            const i = "client" + ("x" === (o || t.scroll) ? "X" : "Y");
            return (m(n, e) ? n : n.touches[0])[i]
        }
        return {
            pointerDown: function(t) {
                return n = t, o = t, s(t)
            },
            pointerMove: function(t) {
                const e = s(t) - s(o),
                    i = r(t) - r(n) > 170;
                return o = t, i && (n = t), e
            },
            pointerUp: function(t) {
                if (!n || !o) return 0;
                const e = s(o) - s(n),
                    c = r(t) - r(n),
                    a = r(t) - r(o) > 170,
                    u = e / c;
                return c && !a && i(u) > .1 ? u : 0
            },
            readPoint: s
        }
    }

    function S(t, e, o, r, s, c, a) {
        const u = [t].concat(r);
        let l, d, f = [],
            p = !1;

        function m(t) {
            return s.measureSize(a.measure(t))
        }
        return {
            init: function(s) {
                c && (d = m(t), f = r.map(m), l = new ResizeObserver((o => {
                    (n(c) || c(s, o)) && function(n) {
                        for (const o of n) {
                            if (p) return;
                            const n = o.target === t,
                                c = r.indexOf(o.target),
                                a = n ? d : f[c];
                            if (i(m(n ? t : r[c]) - a) >= .5) {
                                s.reInit(), e.emit("resize");
                                break
                            }
                        }
                    }(o)
                })), o.requestAnimationFrame((() => {
                    u.forEach((t => l.observe(t)))
                })))
            },
            destroy: function() {
                p = !0, l && l.disconnect()
            }
        }
    }

    function x(t, e, n, o, r) {
        const s = r.measure(10),
            c = r.measure(50),
            a = h(.1, .99);
        let u = !1;

        function l() {
            return !u && !!t.reachedAny(n.get()) && !!t.reachedAny(e.get())
        }
        return {
            shouldConstrain: l,
            constrain: function(r) {
                if (!l()) return;
                const u = t.reachedMin(e.get()) ? "min" : "max",
                    d = i(t[u] - e.get()),
                    f = n.get() - e.get(),
                    p = a.constrain(d / c);
                n.subtract(f * p), !r && i(f) < s && (n.set(t.constrain(n.get())), o.useDuration(25).useBaseFriction())
            },
            toggleActive: function(t) {
                u = !t
            }
        }
    }

    function E(t, e, n, o) {
        const i = e.min + .1,
            r = e.max + .1,
            {
                reachedMin: s,
                reachedMax: c
            } = h(i, r);
        return {
            loop: function(e) {
                if (! function(t) {
                        return 1 === t ? c(n.get()) : -1 === t && s(n.get())
                    }(e)) return;
                const i = t * (-1 * e);
                o.forEach((t => t.add(i)))
            }
        }
    }

    function w(e, o, i, r, s, c, a, u) {
        const l = {
            passive: !0,
            capture: !0
        };
        let d = 0;

        function f(t) {
            "Tab" === t.code && (d = (new Date).getTime())
        }
        return {
            init: function(p) {
                u && (c.add(document, "keydown", f, !1), o.forEach(((o, f) => {
                    c.add(o, "focus", (o => {
                        (n(u) || u(p, o)) && function(n) {
                            if ((new Date).getTime() - d > 10) return;
                            a.emit("slideFocusStart"), e.scrollLeft = 0;
                            const o = i.findIndex((t => t.includes(n)));
                            t(o) && (s.useDuration(0), r.index(o, 0), a.emit("slideFocus"))
                        }(f)
                    }), l)
                })))
            }
        }
    }

    function M(e) {
        let n = e;

        function o(e) {
            return t(e) ? e : e.get()
        }
        return {
            get: function() {
                return n
            },
            set: function(t) {
                n = o(t)
            },
            add: function(t) {
                n += o(t)
            },
            subtract: function(t) {
                n -= o(t)
            }
        }
    }

    function L(t, e) {
        const n = "x" === t.scroll ? function(t) {
                return `translate3d(${t}px,0px,0px)`
            } : function(t) {
                return `translate3d(0px,${t}px,0px)`
            },
            o = e.style;
        let i = null,
            r = !1;
        return {
            clear: function() {
                r || (o.transform = "", e.getAttribute("style") || e.removeAttribute("style"))
            },
            to: function(e) {
                if (r) return;
                const s = (c = t.direction(e), Math.round(100 * c) / 100);
                var c;
                s !== i && (o.transform = n(s), i = s)
            },
            toggleActive: function(t) {
                r = !t
            }
        }
    }

    function T(t, e, n, o, i, r, s, a, u) {
        const l = c(i),
            d = c(i).reverse(),
            f = function() {
                const t = s[0];
                return g(m(d, t), n, !1)
            }().concat(function() {
                const t = e - s[0] - 1;
                return g(m(l, t), -n, !0)
            }());

        function p(t, e) {
            return t.reduce(((t, e) => t - i[e]), e)
        }

        function m(t, e) {
            return t.reduce(((t, n) => p(t, e) > 0 ? t.concat([n]) : t), [])
        }

        function g(i, s, c) {
            const l = function(t) {
                return r.map(((n, i) => ({
                    start: n - o[i] + .5 + t,
                    end: n + e - .5 + t
                })))
            }(s);
            return i.map((e => {
                const o = c ? 0 : -n,
                    i = c ? n : 0,
                    r = c ? "end" : "start",
                    s = l[e][r];
                return {
                    index: e,
                    loopPoint: s,
                    slideLocation: M(-1),
                    translate: L(t, u[e]),
                    target: () => a.get() > s ? o : i
                }
            }))
        }
        return {
            canLoop: function() {
                return f.every((({
                    index: t
                }) => p(l.filter((e => e !== t)), e) <= .1))
            },
            clear: function() {
                f.forEach((t => t.translate.clear()))
            },
            loop: function() {
                f.forEach((t => {
                    const {
                        target: e,
                        translate: n,
                        slideLocation: o
                    } = t, i = e();
                    i !== o.get() && (n.to(i), o.set(i))
                }))
            },
            loopPoints: f
        }
    }

    function D(t, e, o) {
        let i, r = !1;
        return {
            init: function(s) {
                o && (i = new MutationObserver((t => {
                    r || (n(o) || o(s, t)) && function(t) {
                        for (const n of t)
                            if ("childList" === n.type) {
                                s.reInit(), e.emit("slidesChanged");
                                break
                            }
                    }(t)
                })), i.observe(t, {
                    childList: !0
                }))
            },
            destroy: function() {
                i && i.disconnect(), r = !0
            }
        }
    }

    function O(t, e, n, o) {
        const i = {};
        let r, s = null,
            c = null,
            a = !1;
        return {
            init: function() {
                r = new IntersectionObserver((t => {
                    a || (t.forEach((t => {
                        const n = e.indexOf(t.target);
                        i[n] = t
                    })), s = null, c = null, n.emit("slidesInView"))
                }), {
                    root: t.parentElement,
                    threshold: o
                }), e.forEach((t => r.observe(t)))
            },
            destroy: function() {
                r && r.disconnect(), a = !0
            },
            get: function(t = !0) {
                if (t && s) return s;
                if (!t && c) return c;
                const e = function(t) {
                    return f(i).reduce(((e, n) => {
                        const o = parseInt(n),
                            {
                                isIntersecting: r
                            } = i[o];
                        return (t && r || !t && !r) && e.push(o), e
                    }), [])
                }(t);
                return t && (s = e), t || (c = e), e
            }
        }
    }

    function A(e, n, o, r, s, l, d, f, p) {
        const {
            startEdge: m,
            endEdge: g,
            direction: h
        } = e, v = t(o);
        return {
            groupSlides: function(t) {
                return v ? function(t, e) {
                    return c(t).filter((t => t % e == 0)).map((n => t.slice(n, n + e)))
                }(t, o) : function(t) {
                    return t.length ? c(t).reduce(((e, o, c) => {
                        const v = a(e) || 0,
                            b = 0 === v,
                            y = o === u(t),
                            S = s[m] - l[v][m],
                            x = s[m] - l[o][g],
                            E = !r && b ? h(d) : 0,
                            w = i(x - (!r && y ? h(f) : 0) - (S + E));
                        return c && w > n + p && e.push(o), y && e.push(t.length), e
                    }), []).map(((e, n, o) => {
                        const i = Math.max(o[n - 1] || 0);
                        return t.slice(i, e)
                    })) : []
                }(t)
            }
        }
    }

    function I(t, n, o, f, p, m, I) {
        const {
            align: F,
            axis: P,
            direction: N,
            startIndex: V,
            loop: C,
            duration: k,
            dragFree: z,
            dragThreshold: H,
            inViewThreshold: B,
            slidesToScroll: j,
            skipSnaps: q,
            containScroll: R,
            watchResize: W,
            watchSlides: U,
            watchDrag: X,
            watchFocus: G
        } = m, _ = {
            measure: function(t) {
                const {
                    offsetTop: e,
                    offsetLeft: n,
                    offsetWidth: o,
                    offsetHeight: i
                } = t;
                return {
                    top: e,
                    right: n + o,
                    bottom: e + i,
                    left: n,
                    width: o,
                    height: i
                }
            }
        }, Y = _.measure(n), $ = o.map(_.measure), J = function(t, e) {
            const n = "rtl" === e,
                o = "y" === t,
                i = !o && n ? -1 : 1;
            return {
                scroll: o ? "y" : "x",
                cross: o ? "x" : "y",
                startEdge: o ? "top" : n ? "right" : "left",
                endEdge: o ? "bottom" : n ? "left" : "right",
                measureSize: function(t) {
                    const {
                        height: e,
                        width: n
                    } = t;
                    return o ? e : n
                },
                direction: function(t) {
                    return t * i
                }
            }
        }(P, N), Q = J.measureSize(Y), Z = function(t) {
            return {
                measure: function(e) {
                    return t * (e / 100)
                }
            }
        }(Q), K = function(t, n) {
            const o = {
                start: function() {
                    return 0
                },
                center: function(t) {
                    return i(t) / 2
                },
                end: i
            };

            function i(t) {
                return n - t
            }
            return {
                measure: function(i, r) {
                    return e(t) ? o[t](i) : t(n, i, r)
                }
            }
        }(F, Q), tt = !C && !!R, et = C || !!R, {
            slideSizes: nt,
            slideSizesWithGaps: ot,
            startGap: it,
            endGap: rt
        } = function(t, e, n, o, r, s) {
            const {
                measureSize: c,
                startEdge: u,
                endEdge: d
            } = t, f = n[0] && r, p = function() {
                if (!f) return 0;
                const t = n[0];
                return i(e[u] - t[u])
            }(), m = function() {
                if (!f) return 0;
                const t = s.getComputedStyle(a(o));
                return parseFloat(t.getPropertyValue(`margin-${d}`))
            }(), g = n.map(c), h = n.map(((t, e, n) => {
                const o = !e,
                    i = l(n, e);
                return o ? g[e] + p : i ? g[e] + m : n[e + 1][u] - t[u]
            })).map(i);
            return {
                slideSizes: g,
                slideSizesWithGaps: h,
                startGap: p,
                endGap: m
            }
        }(J, Y, $, o, et, p), st = A(J, Q, j, C, Y, $, it, rt, 2), {
            snaps: ct,
            snapsAligned: at
        } = function(t, e, n, o, r) {
            const {
                startEdge: s,
                endEdge: c
            } = t, {
                groupSlides: u
            } = r, l = u(o).map((t => a(t)[c] - t[0][s])).map(i).map(e.measure), d = o.map((t => n[s] - t[s])).map((t => -i(t))), f = u(d).map((t => t[0])).map(((t, e) => t + l[e]));
            return {
                snaps: d,
                snapsAligned: f
            }
        }(J, K, Y, $, st), ut = -a(ct) + a(ot), {
            snapsContained: lt,
            scrollContainLimit: dt
        } = function(t, e, n, o) {
            const i = h(-e + t, 0),
                r = n.map(((t, e) => {
                    const {
                        min: o,
                        max: r
                    } = i, s = i.constrain(t), c = !e, a = l(n, e);
                    return c ? r : a || u(o, s) ? o : u(r, s) ? r : s
                })).map((t => parseFloat(t.toFixed(3)))),
                c = function() {
                    const t = r[0],
                        e = a(r);
                    return h(r.lastIndexOf(t), r.indexOf(e) + 1)
                }();

            function u(t, e) {
                return s(t, e) <= 1
            }
            return {
                snapsContained: function() {
                    if (e <= t + 2) return [i.max];
                    if ("keepSnaps" === o) return r;
                    const {
                        min: n,
                        max: s
                    } = c;
                    return r.slice(n, s)
                }(),
                scrollContainLimit: c
            }
        }(Q, ut, at, R), ft = tt ? lt : at, {
            limit: pt
        } = function(t, e, n) {
            const o = e[0];
            return {
                limit: h(n ? o - t : a(e), o)
            }
        }(ut, ft, C), mt = v(u(ft), V, C), gt = mt.clone(), ht = c(o), vt = function(t, e, n, o) {
            const i = g(),
                r = 1e3 / 60;
            let s = null,
                c = 0,
                a = 0;

            function u(t) {
                if (!a) return;
                s || (s = t, n(), n());
                const i = t - s;
                for (s = t, c += i; c >= r;) n(), c -= r;
                o(c / r), a && (a = e.requestAnimationFrame(u))
            }

            function l() {
                e.cancelAnimationFrame(a), s = null, c = 0, a = 0
            }
            return {
                init: function() {
                    i.add(t, "visibilitychange", (() => {
                        t.hidden && (s = null, c = 0)
                    }))
                },
                destroy: function() {
                    l(), i.clear()
                },
                start: function() {
                    a || (a = e.requestAnimationFrame(u))
                },
                stop: l,
                update: n,
                render: o
            }
        }(f, p, (() => (({
            dragHandler: t,
            scrollBody: e,
            scrollBounds: n,
            options: {
                loop: o
            }
        }) => {
            o || n.constrain(t.pointerDown()), e.seek()
        })(Ft)), (t => (({
            scrollBody: t,
            translate: e,
            location: n,
            offsetLocation: o,
            previousLocation: i,
            scrollLooper: r,
            slideLooper: s,
            dragHandler: c,
            animation: a,
            eventHandler: u,
            scrollBounds: l,
            options: {
                loop: d
            }
        }, f) => {
            const p = t.settled(),
                m = !l.shouldConstrain(),
                g = d ? p : p && m;
            g && !c.pointerDown() && (a.stop(), u.emit("settle")), g || u.emit("scroll");
            const h = n.get() * f + i.get() * (1 - f);
            o.set(h), d && (r.loop(t.direction()), s.loop()), e.to(o.get())
        })(Ft, t))), bt = ft[mt.get()], yt = M(bt), St = M(bt), xt = M(bt), Et = M(bt), wt = function(t, e, n, o, s) {
            let c = 0,
                a = 0,
                u = s,
                l = .68,
                d = t.get(),
                f = 0;

            function p(t) {
                return u = t, g
            }

            function m(t) {
                return l = t, g
            }
            const g = {
                direction: function() {
                    return a
                },
                duration: function() {
                    return u
                },
                velocity: function() {
                    return c
                },
                seek: function() {
                    const e = o.get() - t.get();
                    let i = 0;
                    return u ? (n.set(t), c += e / u, c *= l, d += c, t.add(c), i = d - f) : (c = 0, n.set(o), t.set(o), i = e), a = r(i), f = d, g
                },
                settled: function() {
                    return i(o.get() - e.get()) < .001
                },
                useBaseFriction: function() {
                    return m(.68)
                },
                useBaseDuration: function() {
                    return p(s)
                },
                useFriction: m,
                useDuration: p
            };
            return g
        }(yt, xt, St, Et, k), Mt = function(t, e, n, o, s) {
            const {
                reachedAny: c,
                removeOffset: u,
                constrain: l
            } = o;

            function d(t) {
                return t.concat().sort(((t, e) => i(t) - i(e)))[0]
            }

            function f(e, o) {
                const i = [e, e + n, e - n];
                if (!t) return e;
                if (!o) return d(i);
                const s = i.filter((t => r(t) === o));
                return s.length ? d(s) : a(i) - n
            }
            return {
                byDistance: function(n, o) {
                    const r = s.get() + n,
                        {
                            index: a,
                            distance: d
                        } = function(n) {
                            const o = t ? u(n) : l(n),
                                r = e.map(((t, e) => ({
                                    diff: f(t - o, 0),
                                    index: e
                                }))).sort(((t, e) => i(t.diff) - i(e.diff))),
                                {
                                    index: s
                                } = r[0];
                            return {
                                index: s,
                                distance: o
                            }
                        }(r),
                        p = !t && c(r);
                    return !o || p ? {
                        index: a,
                        distance: n
                    } : {
                        index: a,
                        distance: n + f(e[a] - d, 0)
                    }
                },
                byIndex: function(t, n) {
                    return {
                        index: t,
                        distance: f(e[t] - s.get(), n)
                    }
                },
                shortcut: f
            }
        }(C, ft, ut, pt, Et), Lt = function(t, e, n, o, i, r, s) {
            function c(i) {
                const c = i.distance,
                    a = i.index !== e.get();
                r.add(c), c && (o.duration() ? t.start() : (t.update(), t.render(1), t.update())), a && (n.set(e.get()), e.set(i.index), s.emit("select"))
            }
            return {
                distance: function(t, e) {
                    c(i.byDistance(t, e))
                },
                index: function(t, n) {
                    const o = e.clone().set(t);
                    c(i.byIndex(o.get(), n))
                }
            }
        }(vt, mt, gt, wt, Mt, Et, I), Tt = function(t) {
            const {
                max: e,
                length: n
            } = t;
            return {
                get: function(t) {
                    return n ? (t - e) / -n : 0
                }
            }
        }(pt), Dt = g(), Ot = O(n, o, I, B), {
            slideRegistry: At
        } = function(t, e, n, o, i, r) {
            const {
                groupSlides: s
            } = i, {
                min: c,
                max: f
            } = o;
            return {
                slideRegistry: function() {
                    const o = s(r),
                        i = !t || "keepSnaps" === e;
                    return 1 === n.length ? [r] : i ? o : o.slice(c, f).map(((t, e, n) => {
                        const o = !e,
                            i = l(n, e);
                        return o ? d(a(n[0]) + 1) : i ? d(u(r) - a(n)[0] + 1, a(n)[0]) : t
                    }))
                }()
            }
        }(tt, R, ft, dt, st, ht), It = w(t, o, At, Lt, wt, Dt, I, G), Ft = {
            ownerDocument: f,
            ownerWindow: p,
            eventHandler: I,
            containerRect: Y,
            slideRects: $,
            animation: vt,
            axis: J,
            dragHandler: b(J, t, f, p, Et, y(J, p), yt, vt, Lt, wt, Mt, mt, I, Z, z, H, q, .68, X),
            eventStore: Dt,
            percentOfView: Z,
            index: mt,
            indexPrevious: gt,
            limit: pt,
            location: yt,
            offsetLocation: xt,
            previousLocation: St,
            options: m,
            resizeHandler: S(n, I, p, o, J, W, _),
            scrollBody: wt,
            scrollBounds: x(pt, xt, Et, wt, Z),
            scrollLooper: E(ut, pt, xt, [yt, xt, St, Et]),
            scrollProgress: Tt,
            scrollSnapList: ft.map(Tt.get),
            scrollSnaps: ft,
            scrollTarget: Mt,
            scrollTo: Lt,
            slideLooper: T(J, Q, ut, nt, ot, ct, ft, xt, o),
            slideFocus: It,
            slidesHandler: D(n, I, U),
            slidesInView: Ot,
            slideIndexes: ht,
            slideRegistry: At,
            slidesToScroll: st,
            target: Et,
            translate: L(J, n)
        };
        return Ft
    }
    const F = {
        align: "center",
        axis: "x",
        container: null,
        slides: null,
        containScroll: "trimSnaps",
        direction: "ltr",
        slidesToScroll: 1,
        inViewThreshold: 0,
        breakpoints: {},
        dragFree: !1,
        dragThreshold: 10,
        loop: !1,
        skipSnaps: !1,
        duration: 25,
        startIndex: 0,
        active: !0,
        watchDrag: !0,
        watchResize: !0,
        watchSlides: !0,
        watchFocus: !0
    };

    function P(t) {
        function e(t, e) {
            return p(t, e || {})
        }
        const n = {
            mergeOptions: e,
            optionsAtMedia: function(n) {
                const o = n.breakpoints || {},
                    i = f(o).filter((e => t.matchMedia(e).matches)).map((t => o[t])).reduce(((t, n) => e(t, n)), {});
                return e(n, i)
            },
            optionsMediaQueries: function(e) {
                return e.map((t => f(t.breakpoints || {}))).reduce(((t, e) => t.concat(e)), []).map(t.matchMedia)
            }
        };
        return n
    }

    function N(t, n, o) {
        const i = t.ownerDocument,
            r = i.defaultView,
            s = P(r),
            c = function(t) {
                let e = [];
                return {
                    init: function(n, o) {
                        return e = o.filter((({
                            options: e
                        }) => !1 !== t.optionsAtMedia(e).active)), e.forEach((e => e.init(n, t))), o.reduce(((t, e) => Object.assign(t, {
                            [e.name]: e
                        })), {})
                    },
                    destroy: function() {
                        e = e.filter((t => t.destroy()))
                    }
                }
            }(s),
            a = g(),
            u = function() {
                let t, e = {};

                function n(t) {
                    return e[t] || []
                }
                const o = {
                    init: function(e) {
                        t = e
                    },
                    emit: function(e) {
                        return n(e).forEach((n => n(t, e))), o
                    },
                    off: function(t, i) {
                        return e[t] = n(t).filter((t => t !== i)), o
                    },
                    on: function(t, i) {
                        return e[t] = n(t).concat([i]), o
                    },
                    clear: function() {
                        e = {}
                    }
                };
                return o
            }(),
            {
                mergeOptions: l,
                optionsAtMedia: d,
                optionsMediaQueries: f
            } = s,
            {
                on: p,
                off: m,
                emit: h
            } = u,
            v = O;
        let b, y, S, x, E = !1,
            w = l(F, N.globalOptions),
            M = l(w),
            L = [];

        function T(e) {
            const n = I(t, S, x, i, r, e, u);
            return e.loop && !n.slideLooper.canLoop() ? T(Object.assign({}, e, {
                loop: !1
            })) : n
        }

        function D(n, o) {
            E || (w = l(w, n), M = d(w), L = o || L, function() {
                const {
                    container: n,
                    slides: o
                } = M, i = e(n) ? t.querySelector(n) : n;
                S = i || t.children[0];
                const r = e(o) ? S.querySelectorAll(o) : o;
                x = [].slice.call(r || S.children)
            }(), b = T(M), f([w, ...L.map((({
                options: t
            }) => t))]).forEach((t => a.add(t, "change", O))), M.active && (b.translate.to(b.location.get()), b.animation.init(), b.slidesInView.init(), b.slideFocus.init(k), b.eventHandler.init(k), b.resizeHandler.init(k), b.slidesHandler.init(k), b.options.loop && b.slideLooper.loop(), S.offsetParent && x.length && b.dragHandler.init(k), y = c.init(k, L)))
        }

        function O(t, e) {
            const n = C();
            A(), D(l({
                startIndex: n
            }, t), e), u.emit("reInit")
        }

        function A() {
            b.dragHandler.destroy(), b.eventStore.clear(), b.translate.clear(), b.slideLooper.clear(), b.resizeHandler.destroy(), b.slidesHandler.destroy(), b.slidesInView.destroy(), b.animation.destroy(), c.destroy(), a.clear()
        }

        function V(t, e, n) {
            M.active && !E && (b.scrollBody.useBaseFriction().useDuration(!0 === e ? 0 : M.duration), b.scrollTo.index(t, n || 0))
        }

        function C() {
            return b.index.get()
        }
        const k = {
            canScrollNext: function() {
                return b.index.add(1).get() !== C()
            },
            canScrollPrev: function() {
                return b.index.add(-1).get() !== C()
            },
            containerNode: function() {
                return S
            },
            internalEngine: function() {
                return b
            },
            destroy: function() {
                E || (E = !0, a.clear(), A(), u.emit("destroy"), u.clear())
            },
            off: m,
            on: p,
            emit: h,
            plugins: function() {
                return y
            },
            previousScrollSnap: function() {
                return b.indexPrevious.get()
            },
            reInit: v,
            rootNode: function() {
                return t
            },
            scrollNext: function(t) {
                V(b.index.add(1).get(), t, -1)
            },
            scrollPrev: function(t) {
                V(b.index.add(-1).get(), t, 1)
            },
            scrollProgress: function() {
                return b.scrollProgress.get(b.location.get())
            },
            scrollSnapList: function() {
                return b.scrollSnapList
            },
            scrollTo: V,
            selectedScrollSnap: C,
            slideNodes: function() {
                return x
            },
            slidesInView: function() {
                return b.slidesInView.get()
            },
            slidesNotInView: function() {
                return b.slidesInView.get(!1)
            }
        };
        return D(n, o), setTimeout((() => u.emit("init")), 0), k
    }
    return N.globalOptions = void 0, N
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselAutoHeight = e()
}(this, (function() {
    "use strict";

    function t(t = {}) {
        let e, n = [];
        const o = ["select", "slideFocus"];

        function i() {
            const {
                slideRegistry: t
            } = e.internalEngine(), o = t[e.selectedScrollSnap()];
            return o ? o.map((t => n[t])).reduce(((t, e) => Math.max(t, e)), 0) : null
        }

        function r() {
            null !== i() && (e.containerNode().style.height = `${i()}px`)
        }
        return {
            name: "autoHeight",
            options: t,
            init: function(t) {
                e = t;
                const {
                    options: {
                        axis: i
                    },
                    slideRects: s
                } = e.internalEngine();
                "y" !== i && (n = s.map((t => t.height)), o.forEach((t => e.on(t, r))), r())
            },
            destroy: function() {
                o.forEach((t => e.off(t, r)));
                const t = e.containerNode();
                t.style.height = "", t.getAttribute("style") || t.removeAttribute("style")
            }
        }
    }
    return t.globalOptions = void 0, t
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselAutoScroll = e()
}(this, (function() {
    "use strict";
    const t = {
        direction: "forward",
        speed: 2,
        startDelay: 1e3,
        active: !0,
        breakpoints: {},
        playOnInit: !0,
        stopOnFocusIn: !0,
        stopOnInteraction: !0,
        stopOnMouseEnter: !1,
        rootNode: null
    };

    function e(n = {}) {
        let o, i, r, s, c, a = 0,
            u = !1,
            l = !1;

        function d() {
            if (r) return;
            if (u) return;
            i.emit("autoScroll:play");
            const t = i.internalEngine(),
                {
                    ownerWindow: e
                } = t;
            a = e.setTimeout((() => {
                t.scrollBody = function(t) {
                    const {
                        location: e,
                        previousLocation: n,
                        offsetLocation: r,
                        target: s,
                        scrollTarget: c,
                        index: a,
                        indexPrevious: u,
                        limit: {
                            reachedMin: l,
                            reachedMax: d,
                            constrain: p
                        },
                        options: {
                            loop: m
                        }
                    } = t, g = "forward" === o.direction ? -1 : 1, h = () => E;
                    let v = 0,
                        b = 0,
                        y = e.get(),
                        S = 0,
                        x = !1;
                    const E = {
                        direction: () => b,
                        duration: () => -1,
                        velocity: () => v,
                        settled: () => x,
                        seek: function() {
                            let t = 0;
                            n.set(e), v = g * o.speed, y += v, e.add(v), s.set(e), t = y - S, b = Math.sign(t), S = y;
                            const h = c.byDistance(0, !1).index;
                            a.get() !== h && (u.set(a.get()), a.set(h), i.emit("select"));
                            const w = "forward" === o.direction ? l(r.get()) : d(r.get());
                            if (!m && w) {
                                x = !0;
                                const t = p(e.get());
                                e.set(t), s.set(e), f()
                            }
                            return E
                        },
                        useBaseFriction: h,
                        useBaseDuration: h,
                        useFriction: h,
                        useDuration: h
                    };
                    return E
                }(t), t.animation.start()
            }), s), u = !0
        }

        function f() {
            if (r) return;
            if (!u) return;
            i.emit("autoScroll:stop");
            const t = i.internalEngine(),
                {
                    ownerWindow: e
                } = t;
            t.scrollBody = c, e.clearTimeout(a), a = 0, u = !1
        }

        function p() {
            l || f()
        }

        function m() {
            l || b()
        }

        function g() {
            l = !0, f()
        }

        function h() {
            l = !1, d()
        }

        function v() {
            i.off("settle", v), d()
        }

        function b() {
            i.on("settle", v)
        }
        return {
            name: "autoScroll",
            options: n,
            init: function(a, u) {
                i = a;
                const {
                    mergeOptions: l,
                    optionsAtMedia: v
                } = u, b = l(t, e.globalOptions), y = l(b, n);
                if (o = v(y), i.scrollSnapList().length <= 1) return;
                s = o.startDelay, r = !1, c = i.internalEngine().scrollBody;
                const {
                    eventStore: S
                } = i.internalEngine(), x = !!i.internalEngine().options.watchDrag, E = function(t, e) {
                    const n = t.rootNode();
                    return e && e(n) || n
                }(i, o.rootNode);
                x && i.on("pointerDown", p), x && !o.stopOnInteraction && i.on("pointerUp", m), o.stopOnMouseEnter && S.add(E, "mouseenter", g), o.stopOnMouseEnter && !o.stopOnInteraction && S.add(E, "mouseleave", h), o.stopOnFocusIn && i.on("slideFocusStart", f), o.stopOnFocusIn && !o.stopOnInteraction && S.add(i.containerNode(), "focusout", d), o.playOnInit && d()
            },
            destroy: function() {
                i.off("pointerDown", p).off("pointerUp", m).off("slideFocusStart", f).off("settle", v), f(), r = !0, u = !1
            },
            play: function(t) {
                void 0 !== t && (s = t), d()
            },
            stop: function() {
                u && f()
            },
            reset: function() {
                u && (f(), b())
            },
            isPlaying: function() {
                return u
            }
        }
    }
    return e.globalOptions = void 0, e
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselAutoplay = e()
}(this, (function() {
    "use strict";
    const t = {
        active: !0,
        breakpoints: {},
        delay: 4e3,
        jump: !1,
        playOnInit: !0,
        stopOnFocusIn: !0,
        stopOnInteraction: !0,
        stopOnMouseEnter: !1,
        stopOnLastSnap: !1,
        rootNode: null
    };

    function e(n = {}) {
        let o, i, r, s, c = null,
            a = 0,
            u = !1,
            l = !1,
            d = !1,
            f = !1;

        function p() {
            r || (h() ? d = !0 : (u || i.emit("autoplay:play"), function() {
                const {
                    ownerWindow: t
                } = i.internalEngine();
                t.clearTimeout(a), a = t.setTimeout(x, s[i.selectedScrollSnap()]), c = (new Date).getTime(), i.emit("autoplay:timerset")
            }(), u = !0))
        }

        function m() {
            r || (u && i.emit("autoplay:stop"), function() {
                const {
                    ownerWindow: t
                } = i.internalEngine();
                t.clearTimeout(a), a = 0, c = null, i.emit("autoplay:timerstopped")
            }(), u = !1)
        }

        function g() {
            if (h()) return d = u, m();
            d && p()
        }

        function h() {
            const {
                ownerDocument: t
            } = i.internalEngine();
            return "hidden" === t.visibilityState
        }

        function v() {
            l || m()
        }

        function b() {
            l || p()
        }

        function y() {
            l = !0, m()
        }

        function S() {
            l = !1, p()
        }

        function x() {
            const {
                index: t
            } = i.internalEngine(), e = t.clone().add(1).get(), n = i.scrollSnapList().length - 1, r = o.stopOnLastSnap && e === n;
            if (i.canScrollNext() ? i.scrollNext(f) : i.scrollTo(0, f), i.emit("autoplay:select"), r) return m();
            p()
        }
        return {
            name: "autoplay",
            options: n,
            init: function(c, a) {
                i = c;
                const {
                    mergeOptions: u,
                    optionsAtMedia: l
                } = a, d = u(t, e.globalOptions), h = u(d, n);
                if (o = l(h), i.scrollSnapList().length <= 1) return;
                f = o.jump, r = !1, s = function(t, e) {
                    const n = t.scrollSnapList();
                    return "number" == typeof e ? n.map((() => e)) : e(n, t)
                }(i, o.delay);
                const {
                    eventStore: x,
                    ownerDocument: E
                } = i.internalEngine(), w = !!i.internalEngine().options.watchDrag, M = function(t, e) {
                    const n = t.rootNode();
                    return e && e(n) || n
                }(i, o.rootNode);
                x.add(E, "visibilitychange", g), w && i.on("pointerDown", v), w && !o.stopOnInteraction && i.on("pointerUp", b), o.stopOnMouseEnter && x.add(M, "mouseenter", y), o.stopOnMouseEnter && !o.stopOnInteraction && x.add(M, "mouseleave", S), o.stopOnFocusIn && i.on("slideFocusStart", m), o.stopOnFocusIn && !o.stopOnInteraction && x.add(i.containerNode(), "focusout", p), o.playOnInit && p()
            },
            destroy: function() {
                i.off("pointerDown", v).off("pointerUp", b).off("slideFocusStart", m), m(), r = !0, u = !1
            },
            play: function(t) {
                void 0 !== t && (f = t), p()
            },
            stop: function() {
                u && m()
            },
            reset: function() {
                u && p()
            },
            isPlaying: function() {
                return u
            },
            timeUntilNext: function() {
                return c ? s[i.selectedScrollSnap()] - ((new Date).getTime() - c) : null
            }
        }
    }
    return e.globalOptions = void 0, e
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselClassNames = e()
}(this, (function() {
    "use strict";
    const t = {
        active: !0,
        breakpoints: {},
        snapped: "is-snapped",
        inView: "is-in-view",
        draggable: "is-draggable",
        dragging: "is-dragging",
        loop: "is-loop"
    };

    function e(t) {
        return (Array.isArray(t) ? t : [t]).filter(Boolean)
    }

    function n(t, e) {
        t && e.length && t.classList.remove(...e)
    }

    function o(t, e) {
        t && e.length && t.classList.add(...e)
    }

    function i(r = {}) {
        let s, c, a, u, l = [],
            d = [];
        const f = ["select"],
            p = ["pointerDown", "pointerUp"],
            m = ["slidesInView"],
            g = {
                snapped: [],
                inView: [],
                draggable: [],
                dragging: [],
                loop: []
            };

        function h(t, e) {
            ("pointerDown" === e ? o : n)(a, g.dragging)
        }

        function v(t = [], e = [], i) {
            const r = e.map((t => u[t])),
                s = t.map((t => u[t]));
            return r.forEach((t => n(t, i))), s.forEach((t => o(t, i))), t
        }

        function b() {
            const {
                slideRegistry: t
            } = c.internalEngine(), e = t[c.selectedScrollSnap()];
            l = v(e, l, g.snapped)
        }

        function y() {
            const t = c.slidesInView();
            d = v(t, d, g.inView)
        }
        return {
            name: "classNames",
            options: r,
            init: function(n, l) {
                c = n;
                const {
                    mergeOptions: d,
                    optionsAtMedia: v
                } = l, S = d(t, i.globalOptions), x = d(S, r);
                s = v(x), a = c.rootNode(), u = c.slideNodes();
                const {
                    watchDrag: E,
                    loop: w
                } = c.internalEngine().options, M = !!E;
                s.loop && w && (g.loop = e(s.loop), o(a, g.loop)), s.draggable && M && (g.draggable = e(s.draggable), o(a, g.draggable)), s.dragging && (g.dragging = e(s.dragging), p.forEach((t => c.on(t, h)))), s.snapped && (g.snapped = e(s.snapped), f.forEach((t => c.on(t, b))), b()), s.inView && (g.inView = e(s.inView), m.forEach((t => c.on(t, y))), y())
            },
            destroy: function() {
                p.forEach((t => c.off(t, h))), f.forEach((t => c.off(t, b))), m.forEach((t => c.off(t, y))), n(a, g.loop), n(a, g.draggable), n(a, g.dragging), v([], l, g.snapped), v([], d, g.inView), Object.keys(g).forEach((t => {
                    g[t] = []
                }))
            }
        }
    }
    return i.globalOptions = void 0, i
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselFade = e()
}(this, (function() {
    "use strict";

    function t(t, e, n) {
        return Math.min(Math.max(t, e), n)
    }

    function e(t) {
        return "number" == typeof t && !isNaN(t)
    }

    function n(n = {}) {
        let o, i, r, s, c = [],
            a = 0,
            u = 0,
            l = 0,
            d = !1;

        function f() {
            v(o.selectedScrollSnap(), 1)
        }

        function p() {
            d = !1
        }

        function m() {
            d = !1, a = 0, u = 0
        }

        function g() {
            const t = o.internalEngine().scrollBody.duration();
            u = t ? 0 : 1, d = !0, t || f()
        }

        function h(t) {
            const {
                scrollSnaps: n,
                location: i,
                target: r
            } = o.internalEngine();
            !e(t) || c[t] < .5 || (i.set(n[t]), r.set(i))
        }

        function v(e, n) {
            o.scrollSnapList().forEach(((i, r) => {
                const s = Math.abs(n),
                    u = c[r],
                    f = r === e,
                    p = t(f ? u + s : u - s, 0, 1);
                c[r] = p;
                const m = f && d,
                    g = o.previousScrollSnap();
                m && (c[g] = 1 - p), f && function(t, e) {
                        const {
                            index: n,
                            dragHandler: i,
                            scrollSnaps: r
                        } = o.internalEngine(), s = i.pointerDown(), c = 1 / (r.length - 1);
                        let u = t,
                            d = s ? o.selectedScrollSnap() : o.previousScrollSnap();
                        if (s && u === d) {
                            const t = -1 * Math.sign(a);
                            u = d, d = n.clone().set(d).add(t).get()
                        }
                        l = d * c + (u - d) * c * e
                    }(e, p),
                    function(t) {
                        const e = o.internalEngine().slideRegistry[t],
                            {
                                scrollSnaps: n,
                                containerRect: i
                            } = o.internalEngine(),
                            r = c[t];
                        e.forEach((e => {
                            const s = o.slideNodes()[e].style,
                                c = parseFloat(r.toFixed(2)),
                                a = c > 0,
                                u = function(t) {
                                    const {
                                        axis: e
                                    } = o.internalEngine();
                                    return `translate${e.scroll.toUpperCase()}(${e.direction(t)}px)`
                                }(a ? n[t] : i.width + 2);
                            a && (s.transform = u), s.opacity = c.toString(), s.pointerEvents = r > .5 ? "auto" : "none", a || (s.transform = u)
                        }))
                    }(r)
            }))
        }

        function b() {
            const {
                dragHandler: t,
                index: e,
                scrollBody: n
            } = o.internalEngine(), i = o.selectedScrollSnap();
            if (!t.pointerDown()) return i;
            const r = Math.sign(n.velocity()),
                s = Math.sign(a),
                c = e.clone().set(i).add(-1 * r).get();
            return r && s ? s === r ? c : i : null
        }

        function y() {
            const {
                target: t,
                location: n
            } = o.internalEngine(), r = t.get() - n.get(), s = Math.abs(r) >= 1, l = b(), d = !e(l);
            return function(t) {
                const {
                    dragHandler: n,
                    scrollBody: o
                } = t.internalEngine(), r = n.pointerDown(), s = o.velocity(), l = o.duration(), d = b(), f = !e(d);
                if (r) {
                    if (!s) return;
                    a += s, u = Math.abs(s / i), h(d)
                }
                if (!r) {
                    if (!l || f) return;
                    u += (1 - c[d]) / l, u *= .68
                }
                f || v(d, u)
            }(o), !d && !s && c[l] > .999
        }

        function S() {
            return l
        }
        return {
            name: "fade",
            options: n,
            init: function(e) {
                o = e;
                const n = o.selectedScrollSnap(),
                    {
                        scrollBody: a,
                        containerRect: u,
                        axis: l
                    } = o.internalEngine(),
                    h = l.measureSize(u);
                i = t(.75 * h, 200, 500), d = !1, c = o.scrollSnapList().map(((t, e) => e === n ? 1 : 0)), r = a.settled, s = o.scrollProgress, a.settled = y, o.scrollProgress = S, o.on("select", g).on("slideFocus", f).on("pointerDown", m).on("pointerUp", p),
                    function() {
                        const {
                            translate: t,
                            slideLooper: e
                        } = o.internalEngine();
                        t.clear(), t.toggleActive(!1), e.loopPoints.forEach((({
                            translate: t
                        }) => {
                            t.clear(), t.toggleActive(!1)
                        }))
                    }(), f()
            },
            destroy: function() {
                const {
                    scrollBody: t
                } = o.internalEngine();
                t.settled = r, o.scrollProgress = s, o.off("select", g).off("slideFocus", f).off("pointerDown", m).off("pointerUp", p), o.slideNodes().forEach((t => {
                    const e = t.style;
                    e.opacity = "", e.transform = "", e.pointerEvents = "", t.getAttribute("style") || t.removeAttribute("style")
                }))
            }
        }
    }
    return n.globalOptions = void 0, n
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).EmblaCarouselWheelGestures = e()
}(this, (function() {
    "use strict";

    function t() {
        return (t = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var n = arguments[e];
                for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o])
            }
            return t
        }).apply(this, arguments)
    }

    function e(t, e) {
        if (t.length !== e.length) throw new Error("vectors must be same length");
        return t.map((function(t, n) {
            return t + e[n]
        }))
    }

    function n(t) {
        return Math.max.apply(Math, t.map(Math.abs))
    }

    function o(t) {
        return Object.freeze(t), Object.values(t).forEach((function(t) {
            null === t || "object" != typeof t || Object.isFrozen(t) || o(t)
        })), t
    }
    var i = [1, 18, "undefined" != typeof window && window.innerHeight || 800],
        r = [-1, -1, -1],
        s = o({
            preventWheelAction: !0,
            reverseSign: [!0, !0, !1]
        }),
        c = {
            active: !0,
            breakpoints: {},
            wheelDraggingClass: "is-wheel-dragging",
            forceWheelAxis: void 0,
            target: void 0
        };

    function a(u) {
        var l;
        void 0 === u && (u = {});
        var d = function() {};
        return {
            name: "wheelGestures",
            options: u,
            init: function(f, p) {
                var m, g, h = p.mergeOptions,
                    v = p.optionsAtMedia,
                    b = h(c, a.globalOptions),
                    y = h(b, u);
                l = v(y);
                var S, x = f.internalEngine(),
                    E = null != (m = l.target) ? m : f.containerNode().parentNode,
                    w = null != (g = l.forceWheelAxis) ? g : x.options.axis,
                    M = function(c) {
                        void 0 === c && (c = {});
                        var a, u, l, d = function() {
                                var t = {};

                                function e(e, n) {
                                    t[e] = (t[e] || []).filter((function(t) {
                                        return t !== n
                                    }))
                                }
                                return o({
                                    on: function(n, o) {
                                        return t[n] = (t[n] || []).concat(o),
                                            function() {
                                                return e(n, o)
                                            }
                                    },
                                    off: e,
                                    dispatch: function(e, n) {
                                        e in t && t[e].forEach((function(t) {
                                            return t(n)
                                        }))
                                    }
                                })
                            }(),
                            f = d.on,
                            p = d.off,
                            m = d.dispatch,
                            g = s,
                            h = {
                                isStarted: !1,
                                isStartPublished: !1,
                                isMomentum: !1,
                                startTime: 0,
                                lastAbsDelta: 1 / 0,
                                axisMovement: [0, 0, 0],
                                axisVelocity: [0, 0, 0],
                                accelerationFactors: [],
                                scrollPoints: [],
                                scrollPointsToMerge: [],
                                willEndTimeout: 400
                            },
                            v = !1,
                            b = function(t) {
                                Array.isArray(t) ? t.forEach((function(t) {
                                    return x(t)
                                })) : x(t)
                            },
                            y = function(e) {
                                return void 0 === e && (e = {}), Object.values(e).some((function(t) {
                                    return null == t
                                })) ? g : g = o(t({}, s, g, e))
                            },
                            S = function(n) {
                                var o = t({
                                    event: a,
                                    isStart: !1,
                                    isEnding: !1,
                                    isMomentumCancel: !1,
                                    isMomentum: h.isMomentum,
                                    axisDelta: [0, 0, 0],
                                    axisVelocity: h.axisVelocity,
                                    axisMovement: h.axisMovement,
                                    get axisMovementProjection() {
                                        return e(o.axisMovement, o.axisVelocity.map((function(t) {
                                            return void 0 === e && (e = .996), t * e / (1 - e);
                                            var e
                                        })))
                                    }
                                }, n);
                                m("wheel", t({}, o, {
                                    previous: u
                                })), u = o
                            },
                            x = function(o) {
                                var s, c = function(e) {
                                        return t({}, e, {
                                            axisDelta: e.axisDelta.map((function(t) {
                                                return Math.min(Math.max(-700, t), 700)
                                            }))
                                        })
                                    }(function(e, n) {
                                        if (!n) return e;
                                        var o = !0 === n ? r : n.map((function(t) {
                                            return t ? -1 : 1
                                        }));
                                        return t({}, e, {
                                            axisDelta: e.axisDelta.map((function(t, e) {
                                                return t * o[e]
                                            }))
                                        })
                                    }({
                                        timeStamp: (s = o).timeStamp,
                                        axisDelta: [s.deltaX * i[s.deltaMode], s.deltaY * i[s.deltaMode], (s.deltaZ || 0) * i[s.deltaMode]]
                                    }, g.reverseSign)),
                                    u = c.axisDelta,
                                    l = c.timeStamp,
                                    d = n(u);
                                o.preventDefault && function(t, e) {
                                    var n = g.preventWheelAction,
                                        o = e[0],
                                        i = e[1],
                                        r = e[2];
                                    if ("boolean" == typeof n) return n;
                                    switch (n) {
                                        case "x":
                                            return Math.abs(o) >= t;
                                        case "y":
                                            return Math.abs(i) >= t;
                                        case "z":
                                            return Math.abs(r) >= t;
                                        default:
                                            return !1
                                    }
                                }(d, u) && o.preventDefault(), h.isStarted ? h.isMomentum && d > Math.max(2, 2 * h.lastAbsDelta) && (F(!0), A()) : A(), 0 === d && Object.is && Object.is(o.deltaX, -0) ? v = !0 : (a = o, h.axisMovement = e(h.axisMovement, u), h.lastAbsDelta = d, h.scrollPointsToMerge.push({
                                    axisDelta: u,
                                    timeStamp: l
                                }), E(), S({
                                    axisDelta: u,
                                    isStart: !h.isStartPublished
                                }), h.isStartPublished = !0, I())
                            },
                            E = function() {
                                var t;
                                2 === h.scrollPointsToMerge.length ? (h.scrollPoints.unshift({
                                    axisDeltaSum: h.scrollPointsToMerge.map((function(t) {
                                        return t.axisDelta
                                    })).reduce(e),
                                    timeStamp: (t = h.scrollPointsToMerge.map((function(t) {
                                        return t.timeStamp
                                    })), t.reduce((function(t, e) {
                                        return t + e
                                    })) / t.length)
                                }), M(), h.scrollPointsToMerge.length = 0, h.scrollPoints.length = 1, h.isMomentum || D()) : h.isStartPublished || w()
                            },
                            w = function() {
                                var t;
                                h.axisVelocity = (t = h.scrollPointsToMerge, t[t.length - 1]).axisDelta.map((function(t) {
                                    return t / h.willEndTimeout
                                }))
                            },
                            M = function() {
                                var t = h.scrollPoints,
                                    e = t[0],
                                    n = t[1];
                                if (n && e) {
                                    var o = e.timeStamp - n.timeStamp;
                                    if (!(o <= 0)) {
                                        var i = e.axisDeltaSum.map((function(t) {
                                                return t / o
                                            })),
                                            r = i.map((function(t, e) {
                                                return t / (h.axisVelocity[e] || 1)
                                            }));
                                        h.axisVelocity = i, h.accelerationFactors.push(r), L(o)
                                    }
                                }
                            },
                            L = function(t) {
                                var e = 10 * Math.ceil(t / 10) * 1.2;
                                h.isMomentum || (e = Math.max(100, 2 * e)), h.willEndTimeout = Math.min(1e3, Math.round(e))
                            },
                            T = function(t) {
                                return 0 === t || t <= .96 && t >= .6
                            },
                            D = function() {
                                if (h.accelerationFactors.length >= 5) {
                                    if (v && (v = !1, n(h.axisVelocity) >= .2)) return void O();
                                    var t = h.accelerationFactors.slice(-5);
                                    t.every((function(t) {
                                        var e = !!t.reduce((function(t, e) {
                                                return t && t < 1 && t === e ? 1 : 0
                                            })),
                                            n = t.filter(T).length === t.length;
                                        return e || n
                                    })) && O(), h.accelerationFactors = t
                                }
                            },
                            O = function() {
                                h.isMomentum = !0
                            },
                            A = function() {
                                (h = {
                                    isStarted: !1,
                                    isStartPublished: !1,
                                    isMomentum: !1,
                                    startTime: 0,
                                    lastAbsDelta: 1 / 0,
                                    axisMovement: [0, 0, 0],
                                    axisVelocity: [0, 0, 0],
                                    accelerationFactors: [],
                                    scrollPoints: [],
                                    scrollPointsToMerge: [],
                                    willEndTimeout: 400
                                }).isStarted = !0, h.startTime = Date.now(), u = void 0, v = !1
                            },
                            I = function() {
                                clearTimeout(l), l = setTimeout(F, h.willEndTimeout)
                            },
                            F = function(t) {
                                void 0 === t && (t = !1), h.isStarted && (S(h.isMomentum && t ? {
                                    isEnding: !0,
                                    isMomentumCancel: !0
                                } : {
                                    isEnding: !0
                                }), h.isMomentum = !1, h.isStarted = !1)
                            },
                            P = function(t) {
                                var e = [],
                                    n = function(n) {
                                        n.removeEventListener("wheel", t), e = e.filter((function(t) {
                                            return t !== n
                                        }))
                                    };
                                return o({
                                    observe: function(o) {
                                        return o.addEventListener("wheel", t, {
                                                passive: !1
                                            }), e.push(o),
                                            function() {
                                                return n(o)
                                            }
                                    },
                                    unobserve: n,
                                    disconnect: function() {
                                        e.forEach(n)
                                    }
                                })
                            }(b),
                            N = P.observe,
                            V = P.unobserve,
                            C = P.disconnect;
                        return y(c), o({
                            on: f,
                            off: p,
                            observe: N,
                            unobserve: V,
                            disconnect: C,
                            feedWheel: b,
                            updateOptions: y
                        })
                    }({
                        preventWheelAction: w,
                        reverseSign: [!0, !0, !1]
                    }),
                    L = M.observe(E),
                    T = M.on("wheel", (function(t) {
                        var e = t.axisDelta,
                            n = e[0],
                            o = e[1],
                            i = "x" === w ? o : n,
                            r = t.isEnding && !t.isMomentum || t.isMomentum && t.previous && !t.previous.isMomentum;
                        Math.abs("x" === w ? n : o) > Math.abs(i) && !D && !t.isMomentum && function(t) {
                            try {
                                F(S = new MouseEvent("mousedown", t.event))
                            } catch (t) {
                                return d()
                            }
                            D = !0, document.documentElement.addEventListener("mousemove", A, !0), document.documentElement.addEventListener("mouseup", A, !0), document.documentElement.addEventListener("mousedown", A, !0), l.wheelDraggingClass && E.classList.add(l.wheelDraggingClass)
                        }(t), D && (r ? function(t) {
                            D = !1, F(I("mouseup", t)), O(), l.wheelDraggingClass && E.classList.remove(l.wheelDraggingClass)
                        }(t) : F(I("mousemove", t)))
                    })),
                    D = !1;

                function O() {
                    document.documentElement.removeEventListener("mousemove", A, !0), document.documentElement.removeEventListener("mouseup", A, !0), document.documentElement.removeEventListener("mousedown", A, !0)
                }

                function A(t) {
                    D && t.isTrusted && t.stopImmediatePropagation()
                }

                function I(t, e) {
                    var n, o;
                    if (w === x.options.axis) {
                        var i = e.axisMovement;
                        n = i[0], o = i[1]
                    } else {
                        var r = e.axisMovement;
                        o = r[0], n = r[1]
                    }
                    if (!x.options.skipSnaps && !x.options.dragFree) {
                        var s = x.containerRect.width,
                            c = x.containerRect.height;
                        n = n < 0 ? Math.max(n, -s) : Math.min(n, s), o = o < 0 ? Math.max(o, -c) : Math.min(o, c)
                    }
                    return new MouseEvent(t, {
                        clientX: S.clientX + n,
                        clientY: S.clientY + o,
                        screenX: S.screenX + n,
                        screenY: S.screenY + o,
                        movementX: n,
                        movementY: o,
                        button: 0,
                        bubbles: !0,
                        cancelable: !0,
                        composed: !0
                    })
                }

                function F(t) {
                    f.containerNode().dispatchEvent(t)
                }
                d = function() {
                    L(), T(), O()
                }
            },
            destroy: function() {
                return d()
            }
        }
    }
    return a.globalOptions = void 0, a
}));
class StrongSlider extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.slider = null, this.thumbSlider = null, this.options = this.querySelector("[data-options]"), this.thumbOptions = this.querySelector("[data-thumbs-options]"), this.viewport = this.querySelector(".strong-slider-viewport"), this.thumbsViewport = this.querySelector(".strong-thumbs-slider-viewport"), this.init(), document.addEventListener("shopify:section:load", (() => this.init(event))), document.addEventListener("shopify:section:select", (() => this.init(event))), document.addEventListener("shopify:block:select", (() => this.init(event))), document.addEventListener("product-variant-updated", (() => this.scroolTo(event))), document.addEventListener("product-quick-viewed", (() => this.scroolTo(event)))
    }
    scroolTo(t) {
        this.classList.contains("product-gallery-slider") && this.slider.scrollTo(t.detail.selected.featured_media.position - 1, 600)
    }
    toggleArrows(t, e, n) {
        const o = () => {
            t.canScrollPrev() ? e.removeAttribute("disabled") : e.setAttribute("disabled", "disabled"), t.canScrollNext() ? n.removeAttribute("disabled") : n.setAttribute("disabled", "disabled")
        };
        return t.on("select", o).on("init", o).on("reInit", o), n.removeAttribute("disabled")
    }
    addArrows(t, e, n) {
        const o = () => t.scrollPrev(),
            i = () => t.scrollNext();
        e.addEventListener("click", o, !1), n.addEventListener("click", i, !1);
        const r = this.toggleArrows(t, e, n);
        return () => {
            r(), e.removeEventListener("click", o, !1), n.removeEventListener("click", i, !1)
        }
    }
    addDots(t, e) {
        let n = [];
        const o = () => {
                e.innerHTML = t.scrollSnapList().map((() => '<span class="strong-dot"></span>')).join(""), n = e.querySelectorAll(".strong-dot"), n.forEach(((e, n) => e.addEventListener("click", (() => t.scrollTo(n)), !1)))
            },
            i = () => {
                const e = t.previousScrollSnap(),
                    o = t.selectedScrollSnap();
                n[e].classList.remove("selected"), n[o].classList.add("selected")
            };
        return t.on("init", o).on("reInit", o).on("init", i).on("reInit", i).on("select", i), () => e.innerHTML = ""
    }
    addPagination(t, e) {
        if (!e) return () => {};
        const n = e.querySelector(".current");
        if (!n) return () => {};
        const o = () => {
            const i = t.selectedScrollSnap() + 1;
            n.textContent = String(i);
        };
        // Initialize and bind updates on key events
        t.on("init", o).on("reInit", o).on("select", o);
        // Perform an immediate update in case init already fired
        try { o(); } catch {}
        return () => {}
    }
    addThumbBtnsClickHandlers(t, e) {
        const n = e.slideNodes(),
            o = n.map(((e, n) => () => t.scrollTo(n)));
        return n.forEach(((t, e) => t.addEventListener("click", o[e], !1))), () => n.forEach(((t, e) => t.removeEventListener("click", o[e], !1)))
    }
    addToggleThumbBtnsActive(t, e) {
        const n = e.slideNodes(),
            o = () => {
                e.scrollTo(t.selectedScrollSnap());
                const o = t.previousScrollSnap(),
                    i = t.selectedScrollSnap();
                n[o].classList.remove("selected"), n[i].classList.add("selected")
            };
        return t.on("select", o), e.on("init", o), () => {
            const e = t.selectedScrollSnap();
            n[e].classList.remove("selected")
        }
    }
    addLazyLoad(t) {
        const e = new Set,
            n = t.slideNodes(),
            o = o => {
                if (e.has(o)) return;
                const i = n[o],
                    r = i?.querySelector(".strong-slider-lazy-load-img");
                if (!r) return;
                const s = r.getAttribute("data-src");
                if (!s) return;
                r.src = s, e.add(o);
                const c = () => {
                    r.removeEventListener("load", c), i.classList.add("strong-slider-lazy-load-has-loaded"), requestAnimationFrame((() => {
                        t.reInit(), t.emit("resize")
                    }))
                };
                r.complete && 0 !== r.naturalHeight ? c() : r.addEventListener("load", c)
            },
            i = () => {
                t.slidesInView(!0).forEach(o)
            };
        return t.on("init", i), t.on("reInit", i), t.on("slidesInView", i), t.on("select", (() => {
            const n = t.selectedScrollSnap();
            e.has(n) ? requestAnimationFrame((() => t.emit("resize"))) : o(n)
        })), () => {}
    }
    addLazyLoadForThumbnails(t) {
        const e = new Set,
            n = this.thumbSlider.slideNodes(),
            o = o => {
                if (e.has(o)) return;
                const i = n[o],
                    r = i?.querySelector(".strong-slider-lazy-load-img");
                if (!r) return;
                const s = r.getAttribute("data-src");
                if (!s) return;
                r.src = s, e.add(o);
                const c = () => {
                    r.removeEventListener("load", c), i.classList.add("strong-slider-lazy-load-has-loaded"), requestAnimationFrame((() => {
                        t.reInit(), t.emit("resize")
                    }))
                };
                r.complete && 0 !== r.naturalHeight ? c() : r.addEventListener("load", c)
            },
            i = () => {
                this.thumbSlider.slidesInView(!0).forEach(o)
            };
        return this.thumbSlider.on("init", i), this.thumbSlider.on("reInit", i), this.thumbSlider.on("slidesInView", i), this.thumbSlider.on("select", (() => {
            const t = this.thumbSlider.selectedScrollSnap();
            e.has(t) ? requestAnimationFrame((() => this.thumbSlider.emit("resize"))) : o(t)
        })), () => {}
    }
    init(t) {
        if (!this.options || !this.viewport || this.classList.contains("initialized")) {
            if (Shopify.designMode && t?.detail?.blockId) {
                let e = this.querySelector(`.strong-slide[data-id=${t.detail.blockId}]`)?.getAttribute("data-index");
                e && this.slider.scrollTo(Number(e))
            }
            return
        }
        let e = JSON.parse(this.options.content.textContent),
            n = [EmblaCarouselClassNames()];
        e.watchResize = (t, e) => {
            for (const n of e) {
                if (t.containerNode() === n.target) return !0;
                window.requestAnimationFrame((() => {
                    t.reInit(), t.emit("resize")
                }));
                break
            }
            return !1
        };
        let o = document.querySelector(e._prevBtn),
            i = document.querySelector(e._nextBtn),
            r = document.querySelector(e._dotsNode);
        if (e._autoplay) {
            let t = {
                delay: Number(e._autoplay || 5e3),
                stopOnMouseEnter: !0,
                stopOnInteraction: !1
            };
            n.push(EmblaCarouselAutoplay(t))
        }
        e._autoheight && n.push(EmblaCarouselAutoHeight()), e._fade && n.push(EmblaCarouselFade()), this.slider = EmblaCarousel(this.viewport, e, n);
        const s = this;
        this.slider.on("init", (() => s.classList.add("initialized")));
        this.addLazyLoad(this.slider);
        if (this.thumbOptions && this.thumbsViewport) {
            this.thumbSlider = EmblaCarousel(this.thumbsViewport, JSON.parse(this.thumbOptions.content.textContent)), this.thumbSlider.on("init", (() => this.addLazyLoadForThumbnails(this.thumbSlider)));
            const t = this.addThumbBtnsClickHandlers(this.slider, this.thumbSlider),
                e = this.addToggleThumbBtnsActive(this.slider, this.thumbSlider);
            this.slider.on("destroy", t).on("destroy", e), this.thumbSlider.on("destroy", t).on("destroy", e), this.thumbOptions.remove()
        } else {
            r && this.addDots(this.slider, r)
        }
        // Add simple pagination updater if present
        const a = this.querySelector('.strong-pagination');
        if (a) this.addPagination(this.slider, a);
        o && i && this.addArrows(this.slider, o, i);
        this.options.remove()
    }
}
customElements.define("strong-slider", StrongSlider);
